export class AspectWrap {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    wrapAspect(aspectComponent) {
        let wrapped = aspectComponent;
        this.aspect.activesOf.wrapAspect.forEach((wrapperAt) => {
            if (wrapperAt.wrapAspect) {
                wrapped = wrapperAt.wrapAspect(wrapped);
            }
        });
        return wrapped;
    }
    wrapChildren(aspectChildren) {
        let wrapped = aspectChildren;
        this.aspect.activesOf.wrapChildren.forEach((wrapperAt) => {
            if (wrapperAt.wrapChildren) {
                wrapped = wrapperAt.wrapChildren(wrapped);
            }
        });
        return wrapped;
    }
}
